// extracted by mini-css-extract-plugin
module.exports = {"input":"CheckList_input__23NRo"};